<div *ngIf="origin==='card'" class="wrapper">
  <img loading="lazy" [attr.data-src]="campaigner?.image" [alt]="campaigner?.name">
  <div *ngIf="!campaigner?.descriptions">All the contributions to this campaign will be matched by {{campaigner?.name}}</div>
  <div *ngIf="campaigner?.descriptions">{{campaigner?.descriptions}}</div>
</div>

<div *ngIf="origin==='list'" class="in-list">
  <img loading="lazy" [attr.data-src]="campaigner?.logo" [alt]="campaigner?.name">
  <div class="content-wrapper">
    <div *ngIf="matchingDonation?.currency" class="amount">
      <app-currency-icon [currency]="matchingDonation?.currency"></app-currency-icon> {{matchingDonation?.amount_local | inrFormat:matchingDonation.currency}}
    </div>
    <div class="desc">(Contribution Matched by {{campaigner?.name}})</div>
  </div>
</div>